// Pending subtask state for new-task creation in TaskForm.
import { useState } from 'react';
import { buildPendingSubtaskEntry } from '@/features/tasks/components/forms/useTaskFormPendingSubtasks.helpers';

/**
 * @param {import('@/types').Task} task
 */
export function useTaskFormPendingSubtasks(task) {
  const [pendingSubtasks, setPendingSubtasks] = useState([]);

  const handleAddPendingSubtask = async (parsedData) => {
    setPendingSubtasks((prev) => [
      ...prev,
      buildPendingSubtaskEntry(task, parsedData),
    ]);
  };

  const handleTogglePendingSubtaskComplete = (localId, completed) => {
    setPendingSubtasks((prev) =>
      prev.map((st) => (st.localId === localId ? { ...st, completed } : st)),
    );
  };

  return {
    pendingSubtasks,
    handleAddPendingSubtask,
    handleTogglePendingSubtaskComplete,
  };
}
